/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CapturedSigningDetailsViewModel } from './CapturedSigningDetailsViewModel';
import {
    CapturedSigningDetailsViewModelFromJSON,
    CapturedSigningDetailsViewModelFromJSONTyped,
    CapturedSigningDetailsViewModelToJSON,
} from './CapturedSigningDetailsViewModel';

/**
 * 
 * @export
 * @interface CaptureSigningDetailsCommand
 */
export interface CaptureSigningDetailsCommand {
    /**
     * 
     * @type {number}
     * @memberof CaptureSigningDetailsCommand
     */
    proposalId: number;
    /**
     * 
     * @type {CapturedSigningDetailsViewModel}
     * @memberof CaptureSigningDetailsCommand
     */
    model: CapturedSigningDetailsViewModel;
}

/**
 * Check if a given object implements the CaptureSigningDetailsCommand interface.
 */
export function instanceOfCaptureSigningDetailsCommand(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "proposalId" in value;
    isInstance = isInstance && "model" in value;

    return isInstance;
}

export function CaptureSigningDetailsCommandFromJSON(json: any): CaptureSigningDetailsCommand {
    return CaptureSigningDetailsCommandFromJSONTyped(json, false);
}

export function CaptureSigningDetailsCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaptureSigningDetailsCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'proposalId': json['ProposalId'],
        'model': CapturedSigningDetailsViewModelFromJSON(json['Model']),
    };
}

export function CaptureSigningDetailsCommandToJSON(value?: CaptureSigningDetailsCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ProposalId': value.proposalId,
        'Model': CapturedSigningDetailsViewModelToJSON(value.model),
    };
}

